/* eslint-disable func-names */
import Axios from 'axios';

const httpClient = Axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_ENDPOINT}/`,
});


httpClient.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token && config.method !== 'OPTIONS') {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(null, (error) => {
  if (error.response && [401].includes(error.response.status)) {
    console.error(error.response?.data?.message);
    localStorage.removeItem('token');
    window.location.pathname = '/login';
  }
  return Promise.reject(error);
});

export default httpClient;
